module.exports = __webpack_public_path__ + "static/media/nB1Dk3kVUl.291dac2f.jpg";